import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Team2019 from './Team2019';
import styles from './Accordion.module.scss';



export default function SimpleAccordion() {


    return (
        <div className={styles.container}>

            <Accordion>
                <div className={styles.team2019}>
                    <div>
                        <ul className={styles.row}>
                            <div className={styles.teamcontainer2019} >
                                <li className={styles.listbg} style={{ borderColor: "#F79321" }}>
                                    <AccordionSummary className={styles.accordionbtn}>
                                        <button className={styles.button_new}>
                                            <span>2019</span>
                                            <p>Team</p>
                                        </button>
                                    </AccordionSummary>
                                </li>
                            </div>
                        </ul>
                    </div>
                </div>
                <div className={styles.team2019detail}>
                    <AccordionDetails>
                        <Team2019 />
                    </AccordionDetails>
                </div>
            </Accordion>
        </div>
    );
}

